<div class="page-layout carded fullwidth" fusePerfectScrollbar>

    <div class="top-bg primary"></div>
      <div class="center">
          <table-header headerTitle="{{'TRANSPORTUNIT.TITLE' | translate}}"
                        iconName="group"
                        searchBarTitle="COMMON.SEARCHTITLE"
                        [buttons]="headerButtons"
                        (onSearch)="search($event)"></table-header>
          <div class="mat-elevation-z8 fuse-white mb-16">
            <div fxLayout="column" fxFlex>
              <action-bar [operations]="tableOperations" class="sticky fuse-white"></action-bar>
              <cd-table [tabledata]="tableData"
                        (rowDoubleClick)="doubleClickHandler($event)"
                        (onSelectionChange)="updateOperations()">
              </cd-table>
            </div>
          </div>
    </div>
</div>
